module.exports = __webpack_public_path__ + "static/Capterra-Rating-af91faa861a3c6b7f5a31c83355c125e.png";